export const PLAY_AUDIO = 'PLAY_AUDIO';
export const PAUSE_AUDIO = 'PAUSE_AUDIO';
export const STOP_AUDIO = 'STOP_AUDIO';
export const TOGGLE_AUDIO = 'TOGGLE_AUDIO';

export const playAudio = src => ({ type: PLAY_AUDIO, src });
export const pauseAudio = () => ({ type: PAUSE_AUDIO });
export const stopAudio = () => ({ type: STOP_AUDIO });
export const toggleAudio = () => ({ type: TOGGLE_AUDIO });
